<template>
  <div class="filter-region no-margin-top filter-bar-container">
    <div class="filter-form">
      <el-form :inline="true" :model="formData" size="small">
        <div class="filter-bar-container-left">
          <el-form-item class="no-bg-item">
            <el-radio-group
              class="time-unit-group"
              v-model="formData.timeUnit"
              @change="handleTimeUnitChange"
            >
              <el-radio-button label="day">日</el-radio-button>
              <el-radio-button label="week">周</el-radio-button>
              <el-radio-button label="month">月</el-radio-button>
              <el-radio-button label="year">年</el-radio-button>
              <el-radio-button label="diy">间隔</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="no-bg-item">
            <i
              v-show="formData.timeUnit !== 'diy'"
              class="el-icon-arrow-left"
              @click="modificationTime('previous')"
            ></i>
            <el-date-picker
              ref="datePickerRef"
              :class="[
                'date-picker-content',
                formData.timeUnit === 'diy' ? 'diy-picker' : '',
              ]"
              v-model="formData.date"
              :type="datePickerType"
              :picker-options="{ firstDayOfWeek: 1 }"
              :format="datePickerFormat"
              :placeholder="datePlaceholder"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              @change="selectTime"
            />
            <i
              v-show="formData.timeUnit !== 'diy'"
              class="el-icon-arrow-right"
              @click="modificationTime('next')"
            ></i>
          </el-form-item>
          <el-form-item
            class="item-select"
            v-for="field in fields"
            :key="field.prop"
            :label="field.label"
          >
            <el-select
              v-if="field.type === 'select'"
              v-model="formData[field.prop]"
              :placeholder="field.placeholder || '请选择'"
              clearable
              filterable
            >
              <el-option
                v-for="opt in field.options"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>

            <el-input
              v-else-if="field.type === 'input'"
              v-model="formData[field.prop]"
              :placeholder="field.placeholder"
              clearable
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="filter-btn">
      <el-button
        class="btn-export"
        type="primary"
        plain
        icon="el-icon-download"
        @click="handleExport"
        >导出</el-button
      >
      <el-button-group class="btn-group">
        <el-button
          plain
          class="btn-reset"
          icon="el-icon-refresh"
          @click="handleReset"
        ></el-button>
        <el-button
          type="primary"
          class="btn-search"
          :loading="loading"
          @click="handleSearch"
          >查询</el-button
        >
      </el-button-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonFilterBar",
  props: {
    // 动态字段配置
    fields: {
      type: Array,
      default: () => [],
    },
    // 查询按钮的加载状态
    loading: {
      type: Boolean,
      default: false,
    },
    // 默认初始数据
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        timeUnit: "month", // 默认按月
        date: new Date(), // 默认当前时间
        startTime: "",
        endTime: "",
        ...this.initialValues,
      },
    };
  },
  computed: {
    // 根据选择的时间维度，返回对应的 Element 日期选择器类型
    datePickerType() {
      const map = {
        day: "date",
        week: "week",
        month: "month",
        year: "year",
        diy: "daterange",
      };
      return map[this.formData.timeUnit] || "date";
    },
    datePlaceholder() {
      const map = {
        day: "选择日期",
        week: "选择周",
        month: "选择月份",
        year: "选择年份",
      };
      return map[this.formData.timeUnit];
    },
    // 根据选择的时间维度，返回对应的日期显示格式
    datePickerFormat() {
      const map = {
        day: "yyyy-MM-dd",
        week: "yyyy第WW周",
        month: "yyyy-MM",
        year: "yyyy年",
        diy: "yyyy-MM-dd",
      };
      return map[this.formData.timeUnit] || "";
    },
  },
  mounted() {
    if (
      this.formData.timeUnit === "diy" &&
      !Array.isArray(this.formData.date)
    ) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); // 默认最近 7 天
      this.formData.date = [start, end];
    }
    this.selectTime(this.formData.date);
  },
  methods: {
    // 切换时间维度时，建议清空或调整日期格式
    handleTimeUnitChange() {
      if (this.formData.timeUnit === "diy") {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); // 默认最近 7 天
        this.formData.date = [start, end];
      } else {
        this.formData.date = new Date();
      }
      this.selectTime(this.formData.date);
    },
    selectTime(e) {
      if (!e) return;
      const { timeUnit } = this.formData;
      const handlers = {
        day: (d) => [d, d],
        week: (d) => {
          const start = new Date(d);
          start.setDate(d.getDate() - (d.getDay() || 7) + 1);
          const end = new Date(start);
          end.setDate(start.getDate() + 6);
          return [start, end];
        },
        month: (d) => [
          new Date(d.getFullYear(), d.getMonth(), 1),
          new Date(d.getFullYear(), d.getMonth() + 1, 0),
        ],
        year: (d) => [
          new Date(d.getFullYear(), 0, 1),
          new Date(d.getFullYear(), 11, 31),
        ],
        diy: (range) => {
          if (Array.isArray(range) && range.length === 2) {
            return [new Date(range[0]), new Date(range[1])];
          }
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          return [start, end];
        },
      };
      let [start, end] = handlers[timeUnit](e);
      // 归一化时间：开始时间 00:00:00, 结束时间 23:59:59
      const s = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate(),
        0,
        0,
        0,
        0,
      );
      const n = new Date(
        end.getFullYear(),
        end.getMonth(),
        end.getDate(),
        23,
        59,
        59,
        999,
      );
      this.formData.startTime = s.getTime();
      this.formData.endTime = n.getTime();

      // 使用封装的函数获取展示日期
      this.formData.showDate = this.getShowDate(e, timeUnit);

      this.$emit("search", JSON.parse(JSON.stringify(this.formData)));
    },
    // 获取展示用的日期字符串
    getShowDate(date, timeUnit) {
      if (!date) return "";
      if (timeUnit === "diy") {
        if (Array.isArray(date) && date.length === 2) {
          return `${this.formatDate(new Date(date[0]))} 至 ${this.formatDate(
            new Date(date[1]),
          )}`;
        }
        return "";
      }
      const d = new Date(date);
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");

      switch (timeUnit) {
        case "day":
          return `${y}年${m}月${day}日`;
        case "month":
          return `${y}年${m}月`;
        case "year":
          return `${y}年`;
        case "week": {
          const target = new Date(d.valueOf());
          const dayNr = (d.getDay() + 6) % 7;
          target.setDate(target.getDate() - dayNr + 3);
          const firstThursday = target.valueOf();
          target.setMonth(0, 1);
          if (target.getDay() !== 4) {
            target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7));
          }
          const weekNum = 1 + Math.ceil((firstThursday - target) / 604800000);
          return `${y}第${weekNum.toString().padStart(2, "0")}周`;
        }
        default:
          return "";
      }
    },
    modificationTime(type) {
      const step = type === "next" ? 1 : -1;
      const date = new Date(this.formData.date);
      const { timeUnit } = this.formData;
      const strategies = {
        day: (d) => d.setDate(d.getDate() + step),
        week: (d) => d.setDate(d.getDate() + step * 7),
        month: (d) => d.setMonth(d.getMonth() + step),
        year: (d) => d.setFullYear(d.getFullYear() + step),
      };

      if (strategies[timeUnit]) {
        strategies[timeUnit](date);
        this.formData.date = date;
        this.selectTime(this.formData.date);
      }
    },
    // 格式化  new Date 格式时间
    formatDate(date) {
      if (!date) return "";
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    // 执行查询
    handleSearch() {
      // 深度拷贝一份数据传给父组件
      this.$emit("search", JSON.parse(JSON.stringify(this.formData)));
    },
    // 重置
    handleReset() {
      this.formData = {
        timeUnit: "month",
        date: new Date(),
        ...this.initialValues,
      };
      if (
        this.formData.timeUnit === "diy" &&
        !Array.isArray(this.formData.date)
      ) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.formData.date = [start, end];
      }
      // 清空动态字段
      this.fields.forEach((f) => {
        this.$set(this.formData, f.prop, undefined);
      });
      this.selectTime(this.formData.date);
      this.$emit("reset");
    },
    // 导出
    handleExport() {
      this.$emit("export", JSON.parse(JSON.stringify(this.formData)));
    },
  },
};
</script>

<style scoped lang="scss">
.filter-bar-container {
  background: #fff;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .filter-form {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-width: 0;

    .filter-bar-container-left {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      min-width: 0;
    }

    /* 统一间距与排版 */
    ::v-deep .el-form-item {
      margin-bottom: 0 !important;
      margin-right: 0 !important;
      flex-shrink: 0;

      &.no-bg-item {
        background: transparent !important;
        padding: 0 !important;
      }

      .el-form-item__content {
        width: auto !important;
        display: flex;
        align-items: center;

        .el-icon-arrow-left,
        .el-icon-arrow-right {
          cursor: pointer;
          color: #000000;
          font-weight: 900;
        }
        .el-icon-arrow-left {
          margin-left: 8px;
        }
      }

      .time-unit-group {
        white-space: nowrap;

        .el-radio-button {
          .el-radio-button__inner {
            width: 70px;
            height: 32px;
            padding: 0;
            line-height: 32px;
            text-align: center;
          }
        }
      }

      .date-picker-content {
        width: 100px !important;

        .el-input__inner {
          border: none;
          padding: 0 !important;
          text-align: center;
          cursor: pointer;
          font-weight: 500;
          font-size: 18px;
          color: #000000;
        }

        .el-input__prefix {
          display: none;
        }
      }
      .diy-picker {
        width: 240px !important;
        border: none;
        background: transparent;
        padding: 0;
        display: inline-flex;
        align-items: center;
        margin-left: 8px;

        .el-range-input {
          background: transparent;
          border: none;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
          cursor: pointer;
          width: 95px !important;
          text-align: center;
        }

        .el-range-separator {
          line-height: 32px !important;
          color: #000000;
          font-weight: 500;
          padding: 0 4px;
          width: auto;
        }

        .el-input__icon {
          display: none;
        }
      }

      &.item-select {
        display: flex !important;
        align-items: center;
        flex-wrap: nowrap;
        white-space: nowrap;
        background: #f7f8fa;
        border-radius: 5px;
        padding: 10px 14px;
        flex: 1 1 220px;
        max-width: 280px;
        min-width: 190px;
        margin-right: 10px !important;
        .el-form-item__label {
          font-size: 14px;
          color: #0c0d0e;
          font-family: "AlibabaPuHuiTi_2_55_Regular";
          padding: 0;
          padding-right: 10px;
        }

        .el-form-item__content {
          flex: 1;
          min-width: 0;

          .el-select {
            width: 100%;

            .el-input {
              .el-input__inner {
                padding: 0;
                border: none;
                background: initial;
                font-size: 14px;
                color: #0c0d0e;
                font-family: "AlibabaPuHuiTi_2_55_Regular";
                height: 20px;
                line-height: 20px;
              }

              .el-input__suffix {
                .el-input__suffix-inner {
                  i {
                    font-weight: 900;
                    color: #000000;
                    line-height: 20px;
                  }
                }
              }
            }
          }

          .el-input {
            .el-input__inner {
              padding: 0 7px;
              background-color: initial;
              border: none;
              height: 20px;
              line-height: 20px;
              font-size: 14px;
              color: #0c0d0e;
            }
          }
        }
      }
    }
  }

  .filter-btn {
    height: 100%;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .btn-export {
      height: 40px;
      padding: 0 18px;
      border-radius: 5px;
      line-height: 38px;
      margin-right: 12px;
    }

    .btn-group {
      display: flex;
      align-items: center;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }

      .btn-search {
        width: 84px;
        height: 40px;
        padding: 0;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }
      }
    }
  }
}
</style>
